import { defineMessages } from "@/i18n";
import en from "./en";

export const framesFlightMessages = defineMessages("frames-flight", en);
